import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import './Patients.css'; // Stil için

function Settings({ user }) {
    const [settings, setSettings] = useState({
        smtp_host: '',
        smtp_port: '',
        smtp_user: '',
        smtp_pass: '',
        smtp_secure: 'tls',
        sms_api_key: '',
        sms_api_secret: '',
        sms_sender_title: '',
        clinic_name: '',
        clinic_address: '',
        clinic_phone: '',
        clinic_website: '',
        clinic_logo: '',
        clinic_logo_width: '',
        prescription_footer: '',
        login_background: '',
        license_key: ''
    });
    const [logoFile, setLogoFile] = useState(null); // Seçilen logo dosyası
    const [bgFile, setBgFile] = useState(null); // Seçilen arka plan dosyası
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get('./backend/get_settings.php')
            .then(res => {
                if (res.data) setSettings(res.data);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }, []);

    const handleChange = (e) => {
        setSettings({ ...settings, [e.target.name]: e.target.value });
    };

    const handleFileChange = (e, type) => {
        if (e.target.files && e.target.files[0]) {
            if (type === 'logo') {
                setLogoFile(e.target.files[0]);
                setSettings({ ...settings, clinic_logo: URL.createObjectURL(e.target.files[0]) }); 
            } else if (type === 'bg') {
                setBgFile(e.target.files[0]);
                setSettings({ ...settings, login_background: URL.createObjectURL(e.target.files[0]) });
            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        const formData = new FormData();
        // Tüm ayarları formData'ya ekle
        Object.keys(settings).forEach(key => {
            formData.append(key, settings[key] || ''); // Null değerleri boş string yap
        });
        // Dosya varsa ekle
        if (logoFile) {
            formData.append('clinic_logo_file', logoFile);
        }
        if (bgFile) {
            formData.append('login_background_file', bgFile);
        }

        axios.post('./backend/save_settings.php', formData)
            .then(res => {
                toast.success(res.data.message);
            })
            .catch(err => {
                console.error('Save Error:', err);
                const msg = err.response?.data?.message || err.message || 'Ayarlar kaydedilemedi.';
                toast.error(`Hata: ${msg}`);
            });
    };

    const handleTestEmail = () => {
        if (!settings.smtp_host || !settings.smtp_user || !settings.smtp_pass) {
            toast.error("Lütfen önce SMTP bilgilerini doldurun.");
            return;
        }
        const email = prompt("Test e-postasının gönderileceği adresi girin:", user.email || "");
        if (email) {
            const loadingToast = toast.loading("Test e-postası gönderiliyor...");
            axios.post('./backend/send_test_email.php', { ...settings, test_email: email })
                .then(res => {
                    toast.update(loadingToast, { render: res.data.message, type: "success", isLoading: false, autoClose: 3000 });
                })
                .catch(err => {
                    toast.update(loadingToast, { render: err.response?.data?.message || "Test başarısız.", type: "error", isLoading: false, autoClose: 5000 });
                });
        }
    };

    if (loading) return <div>Yükleniyor...</div>;

    return (
        <div className="patients-container">
            <div className="header-actions">
                <h2>Sistem Ayarları</h2>
            </div>

            <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 5px 20px rgba(0,0,0,0.05)' }}>
                <form onSubmit={handleSubmit}>
                    <h3 style={{ color: '#4e73df', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>Klinik Bilgileri</h3>
                    <div className="responsive-grid-2">
                        <div className="form-group">
                            <label>Klinik Adı</label>
                            <input type="text" name="clinic_name" value={settings.clinic_name || ''} onChange={handleChange} placeholder="Örn: Dentis Diş Kliniği" />
                        </div>
                        <div className="form-group">
                            <label>Telefon</label>
                            <input type="text" name="clinic_phone" value={settings.clinic_phone || ''} onChange={handleChange} placeholder="0212 ..." />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Adres</label>
                            <textarea name="clinic_address" value={settings.clinic_address || ''} onChange={handleChange} style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', minHeight: '80px' }} placeholder="Klinik açık adresi..." />
                        </div>
                        <div className="form-group">
                            <label>Web Sitesi</label>
                            <input type="text" name="clinic_website" value={settings.clinic_website || ''} onChange={handleChange} placeholder="www.dentis.com" />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Klinik Logosu</label>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '10px' }}>
                                {settings.clinic_logo && (
                                    <img src={settings.clinic_logo} alt="Logo Önizleme" className="logo-preview" style={{ width: settings.clinic_logo_width || 'auto' }} />
                                )}
                                <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, 'logo')} />
                            </div>
                            <input 
                                type="text" 
                                name="clinic_logo" 
                                value={settings.clinic_logo || ''} 
                                onChange={(e) => {
                                    handleChange(e);
                                    setLogoFile(null); 
                                }} 
                                placeholder="https://site.com/logo.png veya dosya yükleyin" 
                            />
                            <small style={{color: '#858796'}}>Logo yüklemek için dosya seçin veya URL girin.</small>
                        </div>
                        <div className="form-group">
                            <label>Logo Genişliği (px)</label>
                            <input type="text" name="clinic_logo_width" value={settings.clinic_logo_width || ''} onChange={handleChange} placeholder="Örn: 150px" />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                            <label>Reçete Alt Bilgi (Footer)</label>
                            <textarea name="prescription_footer" value={settings.prescription_footer || ''} onChange={handleChange} style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', minHeight: '60px' }} placeholder="Reçete çıktısının en altında görünecek metin..." />
                        </div>
                    </div>

                    {user.role === 'super_admin' && (
                        <>
                            <h3 style={{ color: '#4e73df', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>Giriş Sayfası Ayarları</h3>
                            <div className="responsive-grid-2">
                                <div className="form-group">
                                    <label>Giriş Ekranı Arka Planı</label>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '10px' }}>
                                        {settings.login_background && (
                                            <img src={settings.login_background} alt="Arka Plan Önizleme" className="logo-preview" style={{ width: '150px', height: '100px', objectFit: 'cover' }} />
                                        )}
                                        <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, 'bg')} />
                                    </div>
                                    <input 
                                        type="text" 
                                        name="login_background" 
                                        value={settings.login_background || ''} 
                                        onChange={(e) => { handleChange(e); setBgFile(null); }} 
                                        placeholder="https://site.com/bg.jpg veya dosya yükleyin" 
                                    />
                                </div>
                            </div>
                        </>
                    )}

                    <h3 style={{ color: '#e74a3b', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>Lisans Bilgileri</h3>
                    <div className="responsive-grid-2">
                        <div className="form-group">
                            <label>Lisans Anahtarı</label>
                            <input type="text" name="license_key" value={settings.license_key || ''} onChange={handleChange} placeholder="XXXX-XXXX-XXXX-XXXX" style={{ borderColor: '#e74a3b' }} />
                        </div>
                    </div>

                    <h3 style={{ color: '#4e73df', borderBottom: '1px solid #eee', paddingBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        E-posta Ayarları (SMTP)
                        <button type="button" onClick={handleTestEmail} className="edit-btn" style={{ fontSize: '0.8rem', padding: '6px 15px' }}>Test Et</button>
                    </h3>
                    <div className="responsive-grid-2">
                        <div className="form-group">
                            <label>SMTP Host</label>
                            <input type="text" name="smtp_host" value={settings.smtp_host} onChange={handleChange} placeholder="mail.ornek.com" />
                        </div>
                        <div className="form-group">
                            <label>SMTP Port</label>
                            <input type="text" name="smtp_port" value={settings.smtp_port} onChange={handleChange} placeholder="587" />
                        </div>
                        <div className="form-group">
                            <label>SMTP Kullanıcı Adı (Email)</label>
                            <input type="text" name="smtp_user" value={settings.smtp_user} onChange={handleChange} />
                        </div>
                        <div className="form-group">
                            <label>SMTP Şifre</label>
                            <input type="password" name="smtp_pass" value={settings.smtp_pass} onChange={handleChange} />
                        </div>
                        <div className="form-group">
                            <label>Güvenlik (TLS/SSL)</label>
                            <select name="smtp_secure" value={settings.smtp_secure} onChange={handleChange} style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '2px solid #eaecf4' }}>
                                <option value="tls">TLS</option>
                                <option value="ssl">SSL</option>
                            </select>
                        </div>
                    </div>

                    <h3 style={{ color: '#1cc88a', borderBottom: '1px solid #eee', paddingBottom: '10px', marginTop: '30px' }}>SMS Ayarları (Hazırlık)</h3>
                    <div className="responsive-grid-2">
                        <div className="form-group">
                            <label>API Key</label>
                            <input type="text" name="sms_api_key" value={settings.sms_api_key} onChange={handleChange} />
                        </div>
                        <div className="form-group">
                            <label>API Secret</label>
                            <input type="password" name="sms_api_secret" value={settings.sms_api_secret} onChange={handleChange} />
                        </div>
                        <div className="form-group">
                            <label>Gönderici Başlığı</label>
                            <input type="text" name="sms_sender_title" value={settings.sms_sender_title} onChange={handleChange} />
                        </div>
                    </div>

                    <button type="submit" className="save-btn" style={{ marginTop: '20px' }}>Ayarları Kaydet</button>
                </form>
            </div>
        </div>
    );
}

export default Settings;